import React from 'react';
import { useState } from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';

export interface SliderItemProps {
  url: string;
  title: string;
}

interface StyledSliderItemProps extends SliderItemProps, JSSClassesProps<ComponentJSSClasses> { }

export const SliderItem = (props: StyledSliderItemProps) => {
  const { url, classes } = props;
  const [pictureError, setPictureError] = useState(false);
  const onErrorHandler = () => {
    setPictureError(true);
  };

  return (
    <div className={classes.container}>
      {pictureError && <div className={classes.defaultPicture} />}
      <div
        className={`swiper-lazy ${classes.sliderPhoto} ${
          pictureError ? classes.hideMe : ''
        }`}
        data-background={url}
        onError={onErrorHandler}
      />
      <div className={`swiper-lazy-preloader`} />
    </div>
  );
};
